import { Controller } from "@hotwired/stimulus";
import { trapFocus, releaseFocusTrap } from "../utils/FocusTrap";

export default class extends Controller {
  static targets = [ "modal", "assessmentWithoutForm" ];

  initialize() {
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.syncFocusTrap = this.syncFocusTrap.bind(this);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  connect() {
    if (this.hasAssessmentWithoutFormTarget) {
      this.alertForAssessmentWithoutForm();
    }

    this._trapping = false;
    this._visibilityObserver = new MutationObserver(() => this.syncFocusTrap());
    this._visibilityObserver.observe(this.element, {
      attributes: true,
      attributeFilter: ["style", "class"],
    });
    if (this.hasModalTarget) {
      this._visibilityObserver.observe(this.modalTarget, {
        attributes: true,
        attributeFilter: ["style", "class"],
      });
    }
    this.syncFocusTrap();
  }

  disconnect() {
    this.deactivateFocusTrap();
    this._visibilityObserver?.disconnect();
    this._visibilityObserver = null;
    if (this.handleKeyDown && typeof document !== "undefined") {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }

  isModalVisible() {
    if (!this.hasModalTarget) return false;
    if (this.modalTarget.classList.contains("hidden")) return false;

    let node = this.modalTarget;
    while (node) {
      const style = window.getComputedStyle(node);
      if (style.display === "none" || style.visibility === "hidden") return false;
      if (node.getAttribute("aria-hidden") === "true") return false;
      node = node.parentElement;
    }
    return true;
  }

  syncFocusTrap() {
    if (this.isModalVisible()) {
      if (!this._trapping) {
        trapFocus(this.modalTarget, {
          previousFocusElement: this._triggerElement || undefined,
        });
        this._trapping = true;
      }
    } else {
      this.deactivateFocusTrap();
    }
  }

  deactivateFocusTrap() {
    if (!this._trapping) return;
    try {
      if (this.hasModalTarget) {
        releaseFocusTrap(this.modalTarget);
      }
    } catch (_error) {
      // Modal node may already be removed during Turbo/teardown.
    }
    this._trapping = false;
    this._triggerElement = null;
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      const nestedTodoModal = document.getElementById("todo_form_container");
      if (nestedTodoModal && !nestedTodoModal.classList.contains("hidden")) {
        return;
      }
      if (this.hasAssessmentWithoutFormTarget) {
        this.closeAlert();
      } else {
        this.close();
      }
    }
  }

  handleCloseKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.close(event);
    }
  }

  open(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    this._triggerElement =
      e?.currentTarget instanceof HTMLElement ? e.currentTarget : document.activeElement;

    const aqueductTable = window.AqueductTable;
    if (aqueductTable){
      aqueductTable.setState({query: {}});
    }

    this.modalTarget.classList.remove("hidden");
    this.syncFocusTrap();
  }

  close() {
    if (this.modalTarget) {
      this.deactivateFocusTrap();
      const subscriberForm = document.querySelector('#subscriber-form');
      if (subscriberForm){
        subscriberForm.reset();
      }

      this.modalTarget.classList.add("hidden");
    }
  }

  alertForAssessmentWithoutForm(){
    const lastShown = localStorage.getItem('assessment_form_last_shown');
    const today = new Date().toISOString().split('T')[0];

    if (lastShown !== today) {
      $(this.assessmentWithoutFormTarget).show().css("background-color", "#2b2b2b42");
    }
  }

  closeAlert(){
    const today = new Date().toISOString().split('T')[0];
    localStorage.setItem('assessment_form_last_shown', today);
    $(this.assessmentWithoutFormTarget).hide();
  }
}
